import React, { useEffect, useMemo, useReducer } from 'react';
import get from 'lodash/get';
import axios from 'axios';
import Loader from '../../components/Loader';
import { useQueryParams } from '../../hooks';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';
import style from './style.module.css';
import config from '../../utilities/Config';

const EmailValidation = () => {
    const token = useQueryParams().get('token');
    const validationEndpoint = config.get('validation.url');
    const { t } = useTranslation();
    const [{ loading, message }, dispatch] = useReducer((state, action) => {
        return { ...state, ...action };
    }, { loading: true, message: '' });

    const onSuccess = (response) => {
        const message = { type: MessageType.Success, description: t('emailValidation.completed') };
        dispatch({ loading: false, message: message });
        return;
    };

    const onFailure = (e) => {
        const statusCode = get(e, 'response.data.statusCode');

        // Invalid Token  
        if (statusCode === "PII004") {
            const message = { type: MessageType.Failure, description: t('emailValidation.error.invalid') };
            dispatch({ loading: false, message: message });
            return;
        }

        // Expired Token  
        if (statusCode === "PII005") {
            const message = { type: MessageType.Failure, description: t('emailValidation.error.expired') };
            dispatch({ loading: false, message: message });
            return;
        }

        // Aready validated  
        if (statusCode === "PII006") {
            const message = { type: MessageType.Failure, description: t('emailValidation.error.validated') };
            dispatch({ loading: false, message: message });
            return;
        }

        const message = { type: MessageType.Failure, description: t('emailValidation.error.unknown') };
        dispatch({ loading: false, message: message });
    };

    useEffect(() => {
        setTimeout(() => {
            axios.post(`${validationEndpoint}?token=${token}`)
                .then(onSuccess)
                .catch(onFailure);
        }, 1000);
    }, []);

    return (
        <React.Fragment>
            <div style={{ fontSize: '24px', padding: '15px', backgroundColor: '#EEE', textAlign: 'left' }}>
                Email Validation
            </div>
            {loading &&
                <Loader text={t('emailValidation.processing')} />
            }
            {message &&
                <div className={style.statusPnl}>
                    <div className={style.statusBox}>
                        <div className={style.statusText}>{message.description}</div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
}

const MessageType = { Success: 'S', Error: 'E' };

export default EmailValidation;

